module.exports = __webpack_public_path__ + "media/images/icon_installments-68fd5f62af9b1f554584e65f23927390.png";